<template>
  <div class="box" @scroll="handleScroll($event)">
    <Header ref="headerNav"/>
    <div class="content">
      <div class="headerbg">
        <span>东云启创直播平台</span>
        <b>DONGYUN QICHUANG LIVE BROADCAST PLATFORM</b>

      </div>
      <div class="mainbody">
        <div class="setionbox">
        <p>《东云启创直播平台》是启创未来（北京）科技有限公司，为积极响应互联网+教育号召，运用云计算、大数据等多种前沿的科学技术，开发建设而成的综合性在线直播平台。平台打破时间和空间的限制，精准实现“课堂进万家”的目标。从而极大的提高学习效率，使学习变得更简单、便捷。</p>
      </div>
      <div class="setionbox">
        <div class="setion">
          <div class="left">
            <p>课程特点</p>
            <div class="line"></div>
            <div class="text">打破时间、空间限制，互动教学，翻转课堂，空中课堂，与名师面对面，降低学习成本，高效学习

</div>
          </div>
          <div class="right"><img  style="width:574px; "src="https://dyqc.oss-accelerate.aliyuncs.com/muke/img/base/图层 542@2x.png" alt=""></div>
        </div>
      </div>

        <div class="setionbox">
        <div class="setion">

          <div class="right"><img  style="width:500px; "src="https://dyqc.oss-accelerate.aliyuncs.com/muke/img/base/组 41 拷贝@2x.png" alt=""></div>
          <div class="left">
            <p>平台功能</p>
            <div class="line"></div>
            <div class="text">随机分组，语音讨论，实时互动，弹幕，在线答疑，直播回放，实时点名

</div>
          </div>
        </div>
      </div>

       <div class="setionbox">
        <div class="setion">
          <div class="left">
            <p>平台优势</p>
            <div class="line"></div>
            <div class="text">实名认证，语音分组，活体检测，管理系统完善，数据抓取、挖掘、分析，人脸识别



</div>
          </div>
          <div class="right"><img  style="width:458px; "src="https://dyqc.oss-accelerate.aliyuncs.com/muke/img/base/组 13 拷贝@2x.png" alt=""></div>
        </div>
      </div>



      </div>
    </div>
    <Footer/>

  </div>
</template>

<script>
export default {
  name: 'DongyunQichuangLiveBroadcastPlatforms',
  methods:{
     handleScroll (e) {
      if(e.srcElement.scrollTop>2){
        this.$refs.headerNav.showHeadBj()
      }else {
        this.$refs.headerNav.hideHeadBj()
      }
      //滚动事件
      // console.log('eeeeeeeee', e.srcElement.scrollTop, e.target.scrollTop)
    },
  }
}
</script>

<style lang="scss" scoped>
.setionbox:nth-child(odd) {
  background: #f8f8f8;
  .left {
    padding-left: 70px;
  }
}
.left {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
  p {
    font-size: 36px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #333333;
  }
  .line {
    margin-top: 20px;
    width: 120px;
    height: 4px;
    background: #f39a21;
  }
  .text {
    width: 468px;
    margin-top: 60px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
     line-height: 1.8;
  }
}
.right {
  flex: 1;
}
.box {
  width: 100%;
  height: 100%;
  overflow: auto;
  // position: relative;
}
.headerbg {
  width: 100%;
  height: 580px;
  background-image: url("~https://dyqc.oss-accelerate.aliyuncs.com/muke/img/base/组 42@2x.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span {
    font-size: 42px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
  b {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #006cda;
  }
}
.setionbox {
  width: 100%;
  // background-color: red;
  .setion {
    margin: 0 auto;
    width: 1200px;
    padding-top: 80px;
    padding-bottom: 80px;
    // background-color: #f5ff;
    display: flex;
  }
}
.mainbody>.setionbox > p {
  padding-top: 30px;
  padding-bottom: 30px;
  width: 1069px;
  margin: 0 auto;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  background: #f8f8f8;
  text-align: center;
  line-height: 1.8;
}
</style>

    




// WEBPACK FOOTER //
// src/pages/DongyunQichuangLiveBroadcastPlatform.vue